// extracted by mini-css-extract-plugin
module.exports = {"container":"_1ubOwTPEmoNbdgagP4Il9d"};